import React, {useState} from "react";
import MainHeader from "../../layouts/pageLayout/MainHeader";
import {Contactlits} from "./Contactlits";

const ContactList = () => {
  const [activeTab, setActiveTab] = useState(0);
  const items = [
    {
      name: "Contract List",
      path: "all-contract-list",
    },
  ];

  return (
    <>
      <div style={{width:'100%'}} className="mainPageHolder">
     
      
            {/* {(isLoading || accountMetrics.error) && <LoaderOverlay desc={accountMetrics.error && accountMetrics.message} />} */}

            {/* <Routes>
              <Route
                path="/"
                element={
                  <Navigate
                    to="all-contract-list"
                    replace={true}
                  />
                }
              />
              <Route
                path="all-contract-list"
                element={}
              />
            </Routes> */}
            <Contactlits />

      </div>
    </>
  );
};

export default ContactList;
